// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ode-primary-bg {
  background-color: #053057;
  color: white;
}

.ode-primary-bg-light {
  background-color: #A2F3F3;
  color: black;
}

.ode-secondary-bg {
  background-color: #00EDED;
  color: black;
}

.ode-secondary-bg-light {
  background-color: #F4F3F0;
  color: black;
}

.ode-tertiary-bg {
  background-color: #FFFFFF;
  color: black;
}

.logo-container {
  padding: 10%;
  display: flex;
  align-items: center;
}

.custom-table .ant-table-thead > tr > th {
  font-size: 14px;
  font-weight: bold;
}
.custom-table .ant-table-tbody > tr > td {
  font-size: 12px;
}

.disabled-input {
  background-color: white !important;
  border: unset !important;
  border-radius: 0;
  color: darkgray !important;
}

.ant-select-selection-placeholder {
  color: black !important;
}

.ant-table-small .ant-table-cell {
  font-size: 12px;
  padding: 8px;
}

.small-table-row {
  font-size: 12px;
}

.custom-button {
  color: #4096ff;
  border-color: #4096ff;
  background: #ffffff;
}

.custom-button:hover,
.custom-button:focus {
  color: #4096ff !important;
  border-color: #4096ff !important;
  background: #ffffff !important;
}

.ant-picker-suffix {
  color: rgba(5, 47, 87, 0.6156862745) !important;
}

@media (min-width: 1300px) {
  .ant-drawer-content-wrapper {
    width: 550px !important;
  }
}
.bold-row {
  font-weight: bold;
}

.bold-input .ant-input-number-input {
  font-weight: bold !important;
}

.ant-collapse-item {
  background-color: white !important;
  border-radius: 10px !important;
  font-weight: bold !important;
  font-size: 16px !important;
}

.ant-collapse {
  border-color: transparent !important;
}

label {
  font-size: 12px !important;
}

.ant-typography,
.ant-btn,
.ant-input,
.ant-select,
.ant-select-selector {
  font-size: 12px !important;
  /* Apply custom font size to specific components */
}

/* Center align only the table headers */
.ant-table-thead > tr > th {
  text-align: center !important;
}

.ant-table-thead .title-column {
  text-align: left !important;
}

.ant-table-thead .month-column {
  text-align: right !important;
}

.ant-table-thead .total-column {
  text-align: right !important;
}

.hubSpotFieldsChangeTable .ant-table-thead > tr > th {
  text-align: left !important;
}

.monthly-summary-table .ant-table-row-level-0 > td {
  font-weight: bold !important;
}

.project-revenue-table .ant-table-row-level-0 > td {
  font-weight: bold !important;
}

.light-red-row {
  background-color: #ffcccc;
}

.ant-table-row-expand-icon {
  background-color: rgba(22, 119, 255, 0.1803921569) !important;
}

.ant-form-item-explain-error {
  font-size: 11px !important;
}

.ant-tooltip-content {
  text-align: justify;
}

.ant-tooltip-inner {
  text-align: justify;
}

.ant-float-btn-square .ant-float-btn-body {
  height: 100%;
}

.ant-table-cell-row-hover {
  background-color: unset !important;
}

.pricing-templates-table .ant-table-tbody > tr > .ant-table-cell-row-hover {
  background-color: #fafafa !important;
}

.row-under-min > .ant-input-disabled {
  background-color: #F5f5f5 !important;
}

.row-under-min > td {
  border-bottom: 3px solid #ff7b6f !important;
  background-color: #FFEFED !important;
}

.row-under-min > td:first-child {
  border-top-left-radius: 8px !important;
  border-bottom-left-radius: 8px !important;
}

.row-under-min > td:last-child {
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}

.row-highlighted > td {
  background-color: #e6f4ff !important;
}

/* For modern browsers */
::placeholder {
  font-size: 13px;
  /* Adjust the size as needed */
}

/* Vendor prefixes for better cross-browser support */
::-webkit-input-placeholder {
  font-size: 13px;
}

::-ms-input-placeholder {
  font-size: 13px;
}

::-ms-input-placeholder {
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/styles/AppLayout.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,YAAA;AACJ;;AAEA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;AACJ;;AAMI;EACI,eAAA;EACA,iBAAA;AAHR;AAOI;EACI,eAAA;AALR;;AASA;EACI,kCAAA;EACA,wBAAA;EACA,gBAAA;EACA,0BAAA;AANJ;;AASA;EACI,uBAAA;AANJ;;AASA;EACI,eAAA;EACA,YAAA;AANJ;;AASA;EACI,eAAA;AANJ;;AASA;EACI,cAAA;EACA,qBAAA;EACA,mBAAA;AANJ;;AASA;;EAEI,yBAAA;EACA,gCAAA;EACA,8BAAA;AANJ;;AAiBA;EACI,+CAAA;AAdJ;;AAiBA;EACI;IACI,uBAAA;EAdN;AACF;AAiBA;EACI,iBAAA;AAfJ;;AAkBA;EACI,4BAAA;AAfJ;;AAkBA;EACI,kCAAA;EACA,8BAAA;EACA,4BAAA;EACA,0BAAA;AAfJ;;AAkBA;EACI,oCAAA;AAfJ;;AAkBA;EACI,0BAAA;AAfJ;;AAkBA;;;;;EAKI,0BAAA;EACA,kDAAA;AAfJ;;AAkBA,wCAAA;AACA;EACI,6BAAA;AAfJ;;AAkBA;EACI,2BAAA;AAfJ;;AAkBA;EACI,4BAAA;AAfJ;;AAkBA;EACI,4BAAA;AAfJ;;AAkBA;EACI,2BAAA;AAfJ;;AAkBA;EACI,4BAAA;AAfJ;;AAkBA;EACI,4BAAA;AAfJ;;AAkBA;EACI,yBAAA;AAfJ;;AAkBA;EACI,6DAAA;AAfJ;;AAkBA;EACI,0BAAA;AAfJ;;AAkBA;EACI,mBAAA;AAfJ;;AAkBA;EACI,mBAAA;AAfJ;;AAkBA;EACI,YAAA;AAfJ;;AAkBA;EACI,kCAAA;AAfJ;;AAoBA;EACI,oCAAA;AAjBJ;;AAoBA;EACI,oCAAA;AAjBJ;;AAoBA;EAEE,2CAAA;EACA,oCAAA;AAlBF;;AAqBA;EAEE,sCAAA;EACA,yCAAA;AAnBF;;AAsBA;EAEE,uCAAA;EACA,0CAAA;AApBF;;AAuBA;EACE,oCAAA;AApBF;;AAuBA,wBAAA;AACA;EACI,eAAA;EACA,8BAAA;AApBJ;;AAuBA,qDAAA;AACA;EACI,eAAA;AApBJ;;AAuBA;EACI,eAAA;AApBJ;;AAuBA;EACI,eAAA;AApBJ","sourcesContent":[".ode-primary-bg {\n    background-color: #053057;\n    color: white;\n}\n\n.ode-primary-bg-light {\n    background-color: #A2F3F3;\n    color: black;\n}\n\n.ode-secondary-bg {\n    background-color: #00EDED;\n    color: black;\n}\n\n.ode-secondary-bg-light {\n    background-color: #F4F3F0;\n    color: black;\n}\n\n.ode-tertiary-bg {\n    background-color: #FFFFFF;\n    color: black;\n}\n\n.logo-container {\n    padding: 10%;\n    display: flex;\n    align-items: center;\n}\n\n// Custom styles for Ant Design Table\n.custom-table {\n\n    // Header styles\n    .ant-table-thead>tr>th {\n        font-size: 14px; // Change font size for the header\n        font-weight: bold; // Optional: make header bold\n    }\n\n    // Body styles\n    .ant-table-tbody>tr>td {\n        font-size: 12px; // Change font size for table data\n    }\n}\n\n.disabled-input {\n    background-color: white !important;\n    border: unset !important;\n    border-radius: 0;\n    color: darkgray !important;\n}\n\n.ant-select-selection-placeholder {\n    color: black !important;\n}\n\n.ant-table-small .ant-table-cell {\n    font-size: 12px;\n    padding: 8px;\n}\n\n.small-table-row {\n    font-size: 12px;\n}\n\n.custom-button {\n    color: #4096ff;\n    border-color: #4096ff;\n    background: #ffffff;\n}\n\n.custom-button:hover,\n.custom-button:focus {\n    color: #4096ff !important;\n    border-color: #4096ff !important;\n    background: #ffffff !important;\n}\n\n// .ant-float-btn-body {\n//     background-color: #053057 !important;\n// }\n\n// .ant-float-btn-icon {\n//     color: white !important;\n// }\n\n.ant-picker-suffix {\n    color: #052f579d !important;\n}\n\n@media (min-width: 1300px) {\n    .ant-drawer-content-wrapper {\n        width: 550px !important;\n    }\n}\n\n.bold-row {\n    font-weight: bold;\n}\n\n.bold-input .ant-input-number-input {\n    font-weight: bold !important;\n}\n\n.ant-collapse-item {\n    background-color: white !important;\n    border-radius: 10px !important;\n    font-weight: bold !important;\n    font-size: 16px !important;\n}\n\n.ant-collapse {\n    border-color: transparent !important;\n}\n\nlabel {\n    font-size: 12px !important;\n}\n\n.ant-typography,\n.ant-btn,\n.ant-input,\n.ant-select,\n.ant-select-selector {\n    font-size: 12px !important;\n    /* Apply custom font size to specific components */\n}\n\n/* Center align only the table headers */\n.ant-table-thead>tr>th {\n    text-align: center !important;\n}\n\n.ant-table-thead .title-column {\n    text-align: left !important;\n}\n\n.ant-table-thead .month-column {\n    text-align: right !important;\n}\n\n.ant-table-thead .total-column {\n    text-align: right !important;\n}\n\n.hubSpotFieldsChangeTable .ant-table-thead>tr>th {\n    text-align: left !important;\n}\n\n.monthly-summary-table .ant-table-row-level-0>td {\n    font-weight: bold !important;\n}\n\n.project-revenue-table .ant-table-row-level-0>td {\n    font-weight: bold !important;\n}\n\n.light-red-row {\n    background-color: #ffcccc;\n}\n\n.ant-table-row-expand-icon {\n    background-color: #1677ff2e !important;\n}\n\n.ant-form-item-explain-error {\n    font-size: 11px !important;\n}\n\n.ant-tooltip-content {\n    text-align: justify;\n}\n\n.ant-tooltip-inner {\n    text-align: justify;\n}\n\n.ant-float-btn-square .ant-float-btn-body {\n    height: 100%;\n}\n\n.ant-table-cell-row-hover {\n    background-color:unset !important;\n}\n\n// Keep hovered template cells opaque so horizontally scrolled content cannot\n// show through the fixed Actions column.\n.pricing-templates-table .ant-table-tbody > tr > .ant-table-cell-row-hover {\n    background-color: #fafafa !important;\n}\n\n.row-under-min > .ant-input-disabled {\n    background-color: #F5f5f5 !important;\n}\n\n.row-under-min > td {\n//   border-top: 3px solid #ff7b6f !important;\n  border-bottom: 3px solid #ff7b6f !important;\n  background-color: #FFEFED !important;\n}\n\n.row-under-min > td:first-child {\n//   border-left: 3px solid #ff7b6f !important;\n  border-top-left-radius: 8px !important;\n  border-bottom-left-radius: 8px !important;\n}\n\n.row-under-min > td:last-child {\n//   border-right: 3px solid #ff7b6f !important;\n  border-top-right-radius: 8px !important;\n  border-bottom-right-radius: 8px !important;\n}\n\n.row-highlighted > td {\n  background-color: #e6f4ff !important;\n}\n\n/* For modern browsers */\n::placeholder {\n    font-size: 13px;\n    /* Adjust the size as needed */\n}\n\n/* Vendor prefixes for better cross-browser support */\n::-webkit-input-placeholder {\n    font-size: 13px;\n}\n\n::-ms-input-placeholder {\n    font-size: 13px;\n}\n\n::-ms-input-placeholder {\n    font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
